document.addEventListener('DOMContentLoaded', () => {
  const decodeMojibakeText = (root = document.body) => {
    const replacements = [
      ['Ã¡', 'á'], ['Ã©', 'é'], ['Ã­', 'í'], ['Ã³', 'ó'], ['Ãº', 'ú'],
      ['Ã', 'Á'], ['Ã‰', 'É'], ['Ã', 'Í'], ['Ã“', 'Ó'], ['Ãš', 'Ú'],
      ['Ã±', 'ñ'], ['Ã‘', 'Ñ'], ['Â·', '·'], ['Â®', '®'], ['Âº', 'º'],
      ['â€”', '—'], ['â€“', '–'], ['â†’', '→'], ['â˜…', '★'], ['Â¡', '¡'], ['Â¿', '¿']
    ];
    const fix = (value) => replacements.reduce((text, pair) => text.split(pair[0]).join(pair[1]), value);

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        return /Ã|Â|â/.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      node.nodeValue = fix(node.nodeValue);
    });
  };

  decodeMojibakeText();
  setTimeout(() => decodeMojibakeText(), 600);
  if ('MutationObserver' in window) {
    const mojibakeObserver = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.addedNodes.length || mutation.type === 'characterData')) {
        decodeMojibakeText();
      }
    });
    mojibakeObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  const mobileToggle = document.querySelector('[data-mobile-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('is-open');
    });
  }

  document.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const root = button.closest('[data-gallery-root]') || document;
      const image = root.querySelector('[data-gallery-main]');
      if (!image) return;
      const src = button.getAttribute('data-image');
      const alt = button.getAttribute('data-alt') || '';
      if (src) {
        image.setAttribute('src', src);
        image.setAttribute('alt', alt);
      }
      root.querySelectorAll('[data-gallery-thumb]').forEach((node) => node.classList.remove('is-active'));
      button.classList.add('is-active');
    });
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const productRoot = form.closest('.claress-product-panel') || form;
    const qtyInput = form.querySelector('[data-qty-input]');
    const up = form.querySelector('[data-qty-up]');
    const down = form.querySelector('[data-qty-down]');
    const picker = form.querySelector('[data-variant-picker]');
    const hidden = form.querySelector('[data-variant-id]');
    const price = productRoot.querySelector('[data-product-price]');
    const compare = productRoot.querySelector('[data-product-compare-price]');
    const submit = form.querySelector('[data-add-to-cart]');
    const submitLabel = form.querySelector('[data-add-to-cart-label]');
    const submitPrice = form.querySelector('[data-add-to-cart-price]');
    const galleryRoot = form.closest('[data-gallery-root]');

    if (picker && hidden) {
      const syncVariant = () => {
        const option = picker.options[picker.selectedIndex];
        if (!option) return;

        hidden.value = picker.value;

        if (price && option.dataset.price) {
          price.textContent = option.dataset.price;
        }

        if (compare) {
          if (option.dataset.comparePrice) {
            compare.textContent = option.dataset.comparePrice;
            compare.classList.remove('is-hidden');
          } else {
            compare.textContent = '';
            compare.classList.add('is-hidden');
          }
        }

        if (submit && submitLabel && submitPrice) {
          const available = option.dataset.available !== 'false';
          submit.disabled = !available;
          submit.setAttribute('aria-disabled', String(!available));
          submitLabel.textContent = available ? (submitLabel.getAttribute('data-label-available') || 'Add to bag') : (submitLabel.getAttribute('data-label-soldout') || 'Sold out');
          submitPrice.textContent = available && option.dataset.price ? option.dataset.price : '';
        }

        if (galleryRoot && option.dataset.image) {
          const mainImage = galleryRoot.querySelector('[data-gallery-main]');
          if (mainImage) {
            mainImage.setAttribute('src', option.dataset.image);
            mainImage.setAttribute('alt', option.dataset.alt || '');
          }

          galleryRoot.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
            thumb.classList.toggle('is-active', thumb.getAttribute('data-image') === option.dataset.image);
          });
        }
      };

      picker.addEventListener('change', syncVariant);
      syncVariant();
    }

    if (qtyInput && up) {
      up.addEventListener('click', () => {
        qtyInput.value = String(Math.max(1, Number(qtyInput.value || 1) + 1));
      });
    }

    if (qtyInput && down) {
      down.addEventListener('click', () => {
        qtyInput.value = String(Math.max(1, Number(qtyInput.value || 1) - 1));
      });
    }
  });

  document.querySelectorAll('[data-reason-selector]').forEach((selector) => {
    const input = selector.querySelector('[data-reason-input]');
    const cards = selector.querySelectorAll('[data-reason-card]');
    cards.forEach((card) => {
      card.addEventListener('click', () => {
        const value = card.getAttribute('data-value') || '';
        if (input) input.value = value;
        cards.forEach((node) => node.classList.toggle('is-active', node === card));
      });
    });
  });

  document.querySelectorAll('[data-char-count]').forEach((counter) => {
    const id = counter.getAttribute('data-char-count');
    const field = id ? document.getElementById(id) : null;
    if (!field) return;
    const sync = () => {
      counter.textContent = `${field.value.length}/${field.getAttribute('maxlength') || ''}`;
    };
    field.addEventListener('input', sync);
    sync();
  });

  document.querySelectorAll('[data-whatsapp-form]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const number = form.getAttribute('data-whatsapp-number') || '';
      const reason = form.querySelector('[name="reason"]')?.value || '';
      const name = form.querySelector('[name="name"]')?.value || '';
      const profession = form.querySelector('[name="profession"]')?.value || '';
      const message = form.querySelector('[name="message"]')?.value || '';
      const lines = ['Hola CLARESS', '', `Motivo: ${reason}`, `Nombre: ${name}`];
      if (profession) lines.push(`Profesión: ${profession}`);
      lines.push('', 'Mensaje:', message);
      window.open(`https://wa.me/${number}?text=${encodeURIComponent(lines.join('\n'))}`, '_blank', 'noopener,noreferrer');
    });
  });
});
  document.querySelectorAll('[data-formula-builder]').forEach((builder) => {
    const max = Number(builder.getAttribute('data-max-select') || 3);
    const ingredientButtons = Array.from(builder.querySelectorAll('[data-formula-ingredient]'));
    const slots = Array.from(builder.querySelectorAll('[data-formula-slot]'));
    const definitions = Array.from(builder.querySelectorAll('[data-formula-definition]')).map((node) => ({
      ingredients: (node.getAttribute('data-ingredients') || '')
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean)
        .sort(),
      title: node.getAttribute('data-title') || '',
      body: node.getAttribute('data-body') || '',
      badge: node.getAttribute('data-badge') || '',
      link: node.getAttribute('data-link') || '',
      linkLabel: node.getAttribute('data-link-label') || 'Ver producto',
      image: node.getAttribute('data-image') || ''
    }));

    const emptyState = builder.querySelector('[data-formula-empty]');
    const matchState = builder.querySelector('[data-formula-match]');
    const resultImage = builder.querySelector('[data-formula-result-image]');
    const resultBadge = builder.querySelector('[data-formula-result-badge]');
    const resultTitle = builder.querySelector('[data-formula-result-title]');
    const resultBody = builder.querySelector('[data-formula-result-body]');
    const resultChips = builder.querySelector('[data-formula-result-chips]');
    const resultLink = builder.querySelector('[data-formula-result-link]');

    const selected = [];

    const syncSlots = () => {
      slots.forEach((slot, index) => {
        const value = selected[index];
        slot.textContent = value ? value.label.slice(0, 10) : String(index + 1);
        slot.classList.toggle('is-filled', Boolean(value));
      });
    };

    const syncButtons = () => {
      ingredientButtons.forEach((button) => {
        const key = button.getAttribute('data-key');
        button.classList.toggle('is-selected', selected.some((item) => item.key === key));
      });
    };

    const syncResult = () => {
      const selectedKeys = selected.map((item) => item.key).sort();
      const hasCompleteSelection = selectedKeys.length === max;
      const match = hasCompleteSelection
        ? definitions.find((definition) =>
            definition.ingredients.length === selectedKeys.length &&
            definition.ingredients.every((key, index) => key === selectedKeys[index])
          )
        : null;

      if (!hasCompleteSelection || !match) {
        if (emptyState) emptyState.hidden = false;
        if (matchState) matchState.hidden = true;
        return;
      }

      if (emptyState) emptyState.hidden = true;
      if (matchState) matchState.hidden = false;

      if (resultImage) {
        resultImage.src = match.image || '';
        resultImage.alt = match.title || '';
        resultImage.hidden = !match.image;
      }

      if (resultBadge) resultBadge.textContent = match.badge;
      if (resultTitle) resultTitle.textContent = match.title;
      if (resultBody) resultBody.textContent = match.body;

      if (resultChips) {
        resultChips.innerHTML = '';
        selected.forEach((item) => {
          const chip = document.createElement('span');
          chip.textContent = item.label;
          resultChips.appendChild(chip);
        });
      }

      if (resultLink) {
        resultLink.textContent = match.linkLabel || 'Ver producto';
        resultLink.href = match.link || '#';
      }
    };

    ingredientButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const key = button.getAttribute('data-key') || '';
        const label = button.getAttribute('data-label') || '';
        const currentIndex = selected.findIndex((item) => item.key === key);

        if (currentIndex >= 0) {
          selected.splice(currentIndex, 1);
        } else {
          if (selected.length >= max) {
            selected.shift();
          }
          selected.push({ key, label });
        }

        syncButtons();
        syncSlots();
        syncResult();
      });
    });

    syncSlots();
    syncButtons();
    syncResult();
  });
  document.querySelectorAll('[data-memory-game]').forEach((game) => {
    const cards = Array.from(game.querySelectorAll('[data-memory-card]'));
    const reward = game.querySelector('[data-memory-reward]');
    const reset = game.querySelector('[data-memory-reset]');
    let opened = [];
    let lock = false;

    const clearGame = () => {
      opened = [];
      lock = false;
      cards.forEach((card) => {
        card.classList.remove('is-flipped', 'is-matched');
      });
      if (reward) reward.hidden = true;
    };

    if (reset) {
      reset.addEventListener('click', clearGame);
    }

    cards.forEach((card) => {
      card.addEventListener('click', () => {
        if (lock || card.classList.contains('is-flipped') || card.classList.contains('is-matched')) return;

        card.classList.add('is-flipped');
        opened.push(card);

        if (opened.length < 2) return;

        const [first, second] = opened;
        const firstPair = first.getAttribute('data-pair');
        const secondPair = second.getAttribute('data-pair');

        if (firstPair && firstPair === secondPair) {
          first.classList.add('is-matched');
          second.classList.add('is-matched');
          opened = [];

          const remaining = cards.some((node) => !node.classList.contains('is-matched'));
          if (!remaining && reward) {
            reward.hidden = false;
          }
          return;
        }

        lock = true;
        window.setTimeout(() => {
          first.classList.remove('is-flipped');
          second.classList.remove('is-flipped');
          opened = [];
          lock = false;
        }, 850);
      });
    });
  });
